export default {"src":"/_next/static/media/arrow.abe3ece9.svg","height":16,"width":62,"blurWidth":0,"blurHeight":0};